/**
 * Enum chiều rộng màn hình co kéo thanh menu
 * vcdoan 05.02.2024
 */
export default {
    Collapse: 1366,
    UnCollapse: 1386,
};
